import type { Components, Theme } from "@mui/material/styles";
import { RadiusToken } from "../../tokens/radii";

export const MuiFormControlLabel: NonNullable<
  Components<Theme>["MuiFormControlLabel"]
> = {
  styleOverrides: {
    root: ({ theme }) => {
      const rmh = theme.vars!.palette.rmh;
      return {
        "& .MuiFormControlLabel-label": {
          ...theme.typography.bodyMdRegular,
          color: rmh.text.primary,
        },
        "&.Mui-disabled .MuiFormControlLabel-label": {
          color: rmh.text.disabled,
        },
        "&.Mui-error .MuiFormControlLabel-label": {
          color: theme.palette.error.main,
        },
      };
    },
  },
  variants: [
    {
      props: { variant: "contained" },
      style: ({ theme }) => ({
        margin: 0,
        padding: theme.spacing(3),
        borderRadius: RadiusToken.MD,
        borderStyle: "solid",
        borderWidth: theme.spacing(0.25),
        borderColor: theme.vars!.palette.rmh.border["1-surface"].rest,
        ...theme.typography.bodyMdRegular,
      }),
    },
  ],
};
